/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_Point_0_TextInputs */

const en_visa_eb5_point_0_text = /** @type {(inputs: Visa_Eb5_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We review whether the proposed enterprise, investment timeline, and business model align with the current EB-5 framework.`)
};

const pt_visa_eb5_point_0_text = /** @type {(inputs: Visa_Eb5_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisamos se a empresa proposta, o cronograma de investimento e o modelo de negócios estão alinhados com a estrutura atual do EB-5.`)
};

const es_visa_eb5_point_0_text = /** @type {(inputs: Visa_Eb5_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisamos si la empresa propuesta, el cronograma de inversión y el modelo de negocio se alinean con el marco actual del EB-5.`)
};

/**
* | output |
* | --- |
* | "We review whether the proposed enterprise, investment timeline, and business model align with the current EB-5 framework." |
*
* @param {Visa_Eb5_Point_0_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_point_0_text = /** @type {((inputs?: Visa_Eb5_Point_0_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_Point_0_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_point_0_text(inputs)
	if (locale === "es") return es_visa_eb5_point_0_text(inputs)
	return en_visa_eb5_point_0_text(inputs)
});